<!-- 予約状況編集画面 カレンダー選択 -->
<!--<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>-->

<style src="@/assets/css/admin_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/admin_parts_main.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/admin_parts_calendar.css" type="text/css" media="all" scoped></style>

<style scoped></style>
<template>
  <div class="contents" id="wiga1Detail">
    <h2>予約状況編集 カレンダー選択</h2>
			<div class="contntMenu"></div>
		<section id="mainContent">
			<section class="inputArea">
			<h3>受診日時選択</h3>
				<p>下記カレンダーよりご希望の日時をお選びください。</p>
				<!-- Calender START -->
				<section class="calendar1weekType">
					<ul class="controller">
						<li class="backMonth" v-if="calender.flagPreMonth" v-on:click="onCalenderPreMonth()">前の月</li>
						<li class="openMonth">{{calender.year}}年{{calender.month}}月</li>
						<li class="nextMonth" v-if="calender.flagNextMonth" v-on:click="onCalenderNextMonth()">次の月</li>
					</ul>
					<!-- 曜日の表示 -->
					<ul class="calendarWeek"><li v-for="week in calender.weekdays" v-bind:key="week">{{week}}</li></ul>
					<!-- 日付、予約状況の表示 -->
					<div class="calendarDay" v-for="i in calender.displayDatesWeekIndexes" v-bind:key="i">
						<dl v-for="j in calender.displayDatesDayIndexes" v-bind:key="j" v-bind:class="getCalenderDateClass(calender.reserveData[i * 7 + j].ckbn)">
							<dt>{{calender.displayDates[i * 7 + j]}}</dt>
							<dd v-if="calender.krkb=='2'" v-show="calender.reserveData[i * 7 + j].isDisplay">
								<ul>
										<li v-for="item in calender.reserveData[i * 7 + j].array" v-bind:key="item.tmzn" v-on:click="onSelectCalender(calender.displayDates[i * 7 + j],item.tmzn)" >{{item.sthm}}</li>
								</ul>
							</dd>
							<dd v-else v-show="calender.reserveData[i * 7 + j].isDisplay">
								<p v-on:click="onSelectCalender(calender.displayDates[i * 7 + j],'ZZ')">{{calender.reserveData[i * 7 + j].strDay}}</p>
							</dd>
						</dl>
					</div>
				</section>
				<!-- Calender END -->
				<div class="btnLst">
					<button class="backBtn" v-on:click="onBack">戻る</button>
				</div>
			</section>
    </section>
    <!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>
<script>
  import { WIGA1DetailCalenderApi } from '@/api'
  import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'WIGA1DetailCalender',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
    // データ
		data() {
			return {
				// 現在時刻
				currentDateTime: {
					// 年
					YYYY: 0,
					// 月
					MM: 0,
					// 日
					DD: 0,
					// 時間
					hh: 0,
					// 分
					mm: 0
				},
				// 現在のカレンダー表示に必要なデータ
				calender: {
					// '日' ～ '土'
					weekdays: ['日', '月', '火', '水', '木', '金', '土'],
					// 表示するカレンダーの年
					year: 0,
					// 表示するカレンダーの月
					month: 0,
					// 前の月、次の月リンクの表示非表示
					// true:表示
					// false:非表示
					flagPreMonth: true,
					flagNextMonth: true,
					// 表示するカレンダーの末尾日付
					monthLastDate: 0,
					// 表示するカレンダーの月の初日の曜日
					firstDayOfWeek: 0,
					// 表示するカレンダーの月の末日の曜日
					lastDayOfWeek: 0,
					// 前月の第５週の表示日（初週に表示）
					preMonthDates: [],
					// 次月の第１週の表示日（初週に表示）
					nextMonthDates: [],
					// カレンダーに表示する日付配列
					displayDates: [],
					// カレンダーに表示する日付配列の行
					// （何週持ってるか）の添え字配列を作成
					displayDatesWeekIndexes: [],
					// カレンダーに表示する日付配列の列
					displayDatesDayIndexes: [0, 1, 2, 3, 4, 5, 6],
					// カレンダー表示用に整形された予約結果配列
					reserveData: [],
					// 枠管理区分
					// 時間帯枠が一つでもあれば時間帯表示となる
					// 1: 日枠表示
					// 2: 時間枠表示
					krkb: ''
				},
				// カレンダーに表示する予約可能な日付、時間帯リスト
				// date 日付
				// tmzn 時間帯コード
				// sthm 開始時間　表示用(HH:MM)
				reserveData: [],
				// １か月分の休業日マスタ
				// date 日付
				// ckbn 休業区分
				calmData: [],
        // モーダルウィンドウ
        modal: {
          // 入力エラー
					validationError: {
						messages: [],
						isShow: false
					},
					// システムエラーダイアログ
          systemError: {
            messages: [
              'システムエラーです。',
              '内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
		created: function() {

			UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::created End')
		},
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        
        UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::firstDisplay Start')

        WIGA1DetailCalenderApi.FirstDisplay({
          token: this.$store.state.auth.token,
          my_ukno: this.$store.state.adminUserChoice.MasterWIGA1.ukno
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {
            
            // レスポンスを受け取る
						
						// 枠管理区分
						this.calender.krkb = responce.data.krkb

						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm

						// 現在のカレンダー表示
						this.calender.year = responce.data.currentDateTime.YYYY
						this.calender.month = responce.data.currentDateTime.MM
						// 表示するカレンダーの末尾日付
						this.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
					 
						// 予約可能データ
						this.reserveData = responce.data.reserveData

						// １か月分の休業日マスタ
						this.calmData = responce.data.calmData

						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
						// カレンダー表示用に整形された予約結果配列の作成
						this.createReserveData()
						// 前の月次の月の表示非表示判定
						this.updateFlagPreNextMonth()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
        }).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::firstDisplay End')
				})
      },
      // カレンダー更新
			updateCalender: function() {
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::updateCalender Start')

				WIGA1DetailCalenderApi.ChangeCalender({
          token: this.$store.state.auth.token,
          my_ukno: this.$store.state.adminUserChoice.MasterWIGA1.ukno,
					calenderYear:  this.calender.year,
					calenderMonth: this.calender.month
				}).then(({responce}) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm
						
						// 表示するカレンダーの末尾日付
						this.calender.monthLastDate = 
							responce.data.calenderData.monthLastDate
						// 表示するカレンダーの月の初日の曜日
						this.calender.firstDayOfWeek = 
							responce.data.calenderData.firstDayOfWeek
						// 表示するカレンダーの月の末日の曜日
						this.calender.lastDayOfWeek = 
							responce.data.calenderData.lastDayOfWeek
						// 前月の第５週の表示日（初週に表示）
						this.calender.preMonthDates = 
							responce.data.calenderData.preMonthDates
						// 次月の第１週の表示日（初週に表示）
						this.calender.nextMonthDates = 
							responce.data.calenderData.nextMonthDates
					 
						// 予約可能データ
						this.reserveData = responce.data.reserveData

						// １か月分の休業日マスタ
						this.calmData = responce.data.calmData

						// カレンダーに表示する日付配列の作成
						this.createDisplayDates()
						// カレンダー表示用に整形された予約結果配列の作成
						this.createReserveData()
						// 前の月次の月の表示非表示判定
						this.updateFlagPreNextMonth()

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {

						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::updateCalender End')
				})

			},
      // 表示系--------------------------------------------------E
      // イベント系----------------------------------------------S
			// 戻るボタン押下時
			onBack: function () {
				
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onBack Start')

				// 予約状況編集に遷移する
				this.$router.push("/WIGA1Detail")

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onBack End')

			},
			// 前の月を押下したとき
			onCalenderPreMonth: function () {

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::onCalenderPreMonth Start")

				// 現在カレンダーで表示されている月の最初の日のDateオブジェクトを作成
				var dateCurrentMonth = new Date(
					this.calender.year, this.calender.month - 1, 1)
				// 前月の最初の日のDateオブジェクトを作成
				var datePreMonth = new Date(
					this.calender.year, this.calender.month - 1, 1)
				datePreMonth.setMonth(dateCurrentMonth.getMonth() - 1)
				// 表示するカレンダーの年、月を変更
				this.calender.year = datePreMonth.getFullYear()
				this.calender.month = datePreMonth.getMonth() + 1
				// カレンダーの更新
				this.updateCalender()
				// 前の月次の月の表示非表示判定
				this.updateFlagPreNextMonth()

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::onCalenderPreMonth End")
			},
			// 次の月を押下したとき
			onCalenderNextMonth: function () {

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::onCalenderNextMonth Start")

				// 現在カレンダーで表示されている月の最初の日のDateオブジェクトを作成
				var dateCurrentMonth = new Date(
					this.calender.year,
					this.calender.month - 1, 1)
				// 次月の最初の日のDateオブジェクトを作成
				// dateCurrentMonth.getMonth()の値が11つまり12月の時は
				// +1されると次年度の1月値が0になる
				var dateNextMonth = new Date(
					this.calender.year,
					this.calender.month - 1, 1)
				dateNextMonth.setMonth(dateCurrentMonth.getMonth() + 1)
				// 表示するカレンダーの年、月を変更
				this.calender.year = dateNextMonth.getFullYear()
				this.calender.month = dateNextMonth.getMonth() + 1
				// カレンダーの更新
				this.updateCalender()
				// 前の月次の月の表示非表示判定
				this.updateFlagPreNextMonth()

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::onCalenderNextMonth End")
			},
			// 前の月次の月の表示非表示判定
			updateFlagPreNextMonth: function () {

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::updateFlagPreNextMonth Start")

				// 現在日付から何か月前までカレンダーに表示するか
				var yuuyoPre = 3
				// 現在日付から何か先までカレンダーに表示するか
				var yuuyoNext = 3

				//  サーバーの現在日付のDateオブジェクトを作成
				var dateServer = new Date(
					this.currentDateTime.YYYY,
					this.currentDateTime.MM - 1, 1)
				// サーバーから取得した現在日時の
				// 現在日付からyuuyoPreか月前の最初の日のDateオブジェクトを作成
				var datePreServer = new Date(
					this.currentDateTime.YYYY,
					this.currentDateTime.MM - 1, 1)
				datePreServer.setMonth(dateServer.getMonth() - yuuyoPre)
				// サーバーから取得した現在日時の
				// 現在日付からyuuyoNextか月後の最初の日のDateオブジェクトを作成
				var dateNextServer = new Date(
					this.currentDateTime.YYYY,
					this.currentDateTime.MM - 1, 1)
				dateNextServer.setMonth(dateServer.getMonth() + yuuyoNext)

				var dateCalender = new Date(
					this.calender.year,
					this.calender.month - 1, 1)
				// 現在カレンダーで表示されている月の
				// 前月の最初の日のDateオブジェクトを作成
				var datePreCalender = new Date(
					this.calender.year,
					this.calender.month - 1, 1)
				datePreCalender.setMonth(dateCalender.getMonth() - 1)
				// 現在カレンダーで表示されている月の
				// 次月の最初の日のDateオブジェクトを作成
				var dateNextCalender = new Date(
					this.calender.year,
					this.calender.month - 1, 1)
				dateNextCalender.setMonth(dateCalender.getMonth() + 1)

				if (datePreCalender.getTime() >= datePreServer.getTime()) {
					this.calender.flagPreMonth = true
				}
				else {
					this.calender.flagPreMonth = false
				}
				if (dateNextCalender.getTime() <= dateNextServer.getTime()) {
					this.calender.flagNextMonth = true
				}
				else {
					this.calender.flagNextMonth = false
				}

				UtilityConsoleLog.consoleLog("WIGA1CalenderDetail::updateFlagPreNextMonth End")
			},
			onSelectCalender: function(in_date,in_tmzn){
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSelectCalender Start')

				// ストアに保存
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIGA1_CHOICEDATETMZN,
					{
						changeDateYear: this.calender.year,
						changeDateMonth: this.calender.month,
            changeDateDate: in_date,
            changeDateTmzn: in_tmzn,
					}
				)

				// 予約状況編集画面に遷移
				this.$router.push("/WIGA1Detail")

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSelectCalender End')
			},
      // イベント系----------------------------------------------E
			// カレンダーに表示する日付配列の作成
			createDisplayDates: function () {
				
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::createDisplayDates Start');

				// カレンダーに表示する日付配列の行
				// （何週持ってるか）の添え字配列を作成
				var weekLength = this.checkNumWeeksOfDisplayDates()

				this.calender.displayDatesWeekIndexes = []
				for (var i = 0; i < weekLength; i++) {
					this.calender.displayDatesWeekIndexes.push(i)
				}

				// カレンダーに表示する日付配列の初期化
				this.calender.displayDates = []
				// 作成用の配列
				var tempDisplayDates = []
				// 前月の最大値
				var indexMaxPreMonth = this.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.calender.nextMonthDates.length

				// 前月分の日付配列を作成--------------------------------S
				var indexStart = 0
				var indexMax = indexMaxPreMonth

				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.calender.preMonthDates[i])
				}
				// 前月分の日付配列を作成--------------------------------E
				// 当月分の日付配列を作成--------------------------------S
				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;
				// 日付配列の値（1～31）
				var valueOfCurrentDate = 1

				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(valueOfCurrentDate)
					valueOfCurrentDate++
				}
				// 当月分の日付配列を作成--------------------------------E
				// 次月分の日付配列を作成--------------------------------S
				var indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				var indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth
				// 次月分の日付配列インデックス
				var indexNextMonthDates = 0

				// 次月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {
					tempDisplayDates.push(this.calender.nextMonthDates[indexNextMonthDates])
					indexNextMonthDates++
				}

				// 次月分の日付配列を作成--------------------------------E
				// カレンダーに表示する日付配列に代入
				this.calender.displayDates = tempDisplayDates

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::createDisplayDates End');
			},
			// カレンダーに表示する日付配列が何週間分の情報を持つべきか返す
			checkNumWeeksOfDisplayDates: function () {

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::checkNumWeeksOfDisplayDates Start');

				var numDate = this.calender.firstDayOfWeek
				 + this.calender.monthLastDate

				var numWeek = Math.floor((numDate / 7)) + 1

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::checkNumWeeksOfDisplayDates End');

				return numWeek
			},
			// カレンダー表示用に整形された予約結果配列の作成
			createReserveData: function() {

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::createReserveData Start')

				// カレンダー表示用の予約結果配列の初期化
				this.calender.reserveData = []
				// 作成用の配列
				var tempReserveData = []

				// 前月の最大値
				var indexMaxPreMonth = this.calender.preMonthDates.length
				// 当月の最大値
				var indexMaxCurrentMonth = this.calender.monthLastDate
				// 来月の最大値
				var indexMaxNextMonth = this.calender.nextMonthDates.length

				// 前月分の日付配列を作成
				var indexStart = 0
				var indexMax = indexMaxPreMonth

				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(
						this.createReserveDataOneDay(
							0,i
						))
				}

				// 当月分の日付配列を作成
				indexStart = indexMaxPreMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth;

				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(
						this.createReserveDataOneDay(
							1,i
						))
				}

				// 次月分の日付配列を作成
				indexStart = indexMaxPreMonth + indexMaxCurrentMonth
				indexMax = indexMaxPreMonth + indexMaxCurrentMonth + indexMaxNextMonth

				// 次月用の配列の値
				for (var i = indexStart; i < indexMax; i++) {
					tempReserveData.push(
						this.createReserveDataOneDay(
							2,i
						))
				}

				// カレンダーに表示する日付配列に代入
				this.calender.reserveData = tempReserveData

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::createReserveData End')
			},
			createReserveDataOneDay: function(
				in_flagPreCurrentNextMonth,in_indexDisplayDates) {
				
				var resultObject = null
				// 予約できる時間帯と開始時間　表示用(HH:MM)
				var tempArray = []
				// 日枠の場合に画面に表示する文字列
				// 予約可能「○」
				// 予約不可「''」（空文字）
				var tempStrDay = ''

				// 現在の日付
				var tempDate = this.calender.displayDates[in_indexDisplayDates]
				// 現在の日付（文字列）
				var tempStrDate = this.convertDateYYYYMMDD(
					this.calender.year,
					this.calender.month,
					tempDate)
				// 現在の休業区分
				var tempCkbn = '0'

				if (in_flagPreCurrentNextMonth == 0
						|| in_flagPreCurrentNextMonth == 2) {

						resultObject = this.createFormatReserveData(
							false,tempCkbn,tempStrDay,tempArray
						)
				} else {

					var tempCalmDate = this.calmData.filter((item)=>{
						return item.date == tempStrDate
					})

					tempCkbn = tempCalmDate[0].ckbn

					var tempReserveDataOneDay = this.reserveData.filter((item)=>{
						return item.date == tempStrDate
					})

					if( '2' == this.calender.krkb ) {
            // 時間帯枠表示枠
						for(var i=0;i<tempReserveDataOneDay.length;i++){
							tempArray.push({
								tmzn: tempReserveDataOneDay[i].tmzn,
								sthm: tempReserveDataOneDay[i].sthm
							})
						}
					} else {
						// 日枠表示時
						if (tempReserveDataOneDay.length == 1) {
							tempStrDay = '○'
						}
					}
					
					resultObject = this.createFormatReserveData(
						true,tempCkbn,tempStrDay,tempArray
					)
				}

				return resultObject

			},
			// 一日ごとの予約情報のオブジェクトのフォーマット
			createFormatReserveData: function(
				in_isDisplay,in_ckbn,in_strDay,in_array
			){
				return {
					isDisplay: in_isDisplay,
					ckbn: in_ckbn,
					strDay: in_strDay,
					array: in_array
				}
			},
			// YYYY/MM/DDの形式に整形する
			convertDateYYYYMMDD: function (year, month, dd) {

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::convertDateYYYYMMDD Start')

				var tempYear = String(year)
				var tempMonth = String(month)
				var tempDate = String(dd)

				var tempYYYYMMDD = ''

				if (tempMonth.length == 1) {
					tempMonth = '0' + tempMonth
				}

				if (tempDate.length == 1) {
					tempDate = '0' + tempDate
				}

				tempYYYYMMDD = tempYear + '/' + tempMonth + '/' + tempDate

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::convertDateYYYYMMDD End')

				return tempYYYYMMDD
			},
			// カレンダーの日付ごとのクラスを設定する
			// '1': 休業日
			// '9': 営業日
			// '0': 表示月の範囲外の日付
			getCalenderDateClass(in_ckbn){
				var resultClassName = ''

				if('1' == in_ckbn) {
					resultClassName = 'restCalenderDate' 
				} else if('9' == in_ckbn) {
					resultClassName = 'businessCalenderDate'
				} else if('0' == in_ckbn) {
					resultClassName = 'outsideCalenderDate'
				}

				return resultClassName
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			onValidationErrorModalOpen: function (errorMessages) {

				UtilityConsoleLog.consoleLog('CommonSelectCalender::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('CommonSelectCalender::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('CommonSelectCalender::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('CommonSelectCalender::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::onSystemErrorModalClose End')
			},
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('WIGA1CalenderDetail::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIGA1/WIGA1DetailCalender.vue